@if (!getExperimentError) {
  @if (displayToast) {
    <div id="toast">
      <app-toast [style]="'critical'" icon="warning" [text]="csvError?.message">
      </app-toast>
    </div>
  }
  <div id="experiment--container">
    <div id="nav--container">
      <app-option-tab-toggle
        id="toggle--container"
        radioGroup="navigationToggle"
        [selectOptions]="navOptions"
        type="round"
      >
      </app-option-tab-toggle>
    </div>
    <hr />
    <div id="inner-page--container">
      <div id="select-device--container">
        @if (deviceCheckboxesAreInitialised) {
          <app-checkbox-group
            id="checkbox--container"
            [parentForm]="deviceSelectorForm"
            [field]="deviceCheckboxesField"
            (checkboxClicked)="deviceCheckboxClicked($event)"
          ></app-checkbox-group>
        }
        <app-icon-button
          label="refresh"
          buttonId="refresh-btn"
          (buttonClicked)="getExperiment()"
          [isProcessing]="loadingDeviceSummary"
          iconName="autorenew"
          buttonShape="square"
          buttonStyle="outlined"
        ></app-icon-button>
      </div>
      <hr />
      <div id="device--container">
        @if (selectedDevices?.length > 0) {
          <section class="device-summary--container">
            @for (device of selectedDevices; track device.id) {
              <app-device-info-card
                [device]="device"
                [lastUpdateTime]="deviceListLastUpdated"
                [experiment]="experiment"
                (pauseDeviceClicked)="pauseRestartButtonClicked($event)"
                [buttonDisabled]="
                  !hasEditAccess() ||
                  experiment?.experimentStatusId ===
                    ExperimentStatus.Complete ||
                  experiment?.isDeleted ||
                  !device?.isParticipating ||
                  (device?.deviceStatusId !== DeviceSetupStatus.Active &&
                    device?.deviceStatusId !== DeviceSetupStatus.Paused)
                "
              ></app-device-info-card>
            }
          </section>
        } @else {
          <section id="placeholder--container">
            <h4>No devices selected</h4>
            <p class="body1">
              Use the checkboxes above to choose device summaries to display
            </p>
          </section>
        }
      </div>
      <hr />
      <section id="data--container">
        <div class="experiment-overview--container">
          <div class="header--container">
            <div id="overview-title">
              <h4>Experiment Overview</h4>
              @if (experiment?.isDeleted === false) {
                <app-status-indicator
                  class="experiment-status"
                  [status]="ExperimentStatus[experiment?.experimentStatusId]"
                ></app-status-indicator>
              }
              @if (experiment?.isDeleted) {
                <app-status-indicator
                  class="experiment-status"
                  status="Deleted"
                ></app-status-indicator>
              }
            </div>
            <div class="buttons--container">
              <app-icon-button
                label="Update Graphs"
                buttonId="update-btn"
                buttonStyle="outlined"
                (buttonClicked)="getExperimentData()"
                [isProcessing]="loadingOpticalDensity"
                iconName="autorenew"
                buttonShape="square"
              ></app-icon-button>
              <app-icon-button
                label="make parameter changes"
                buttonId="control-btn"
                [routerLink]="'/experiment/' + experiment?.id + '/control'"
                [isDisabled]="
                  experiment?.experimentStatusId !== ExperimentStatus.Active
                "
                buttonStyle="outlined"
                iconName="swap_vert"
                buttonShape="square"
              ></app-icon-button>
            </div>
          </div>
          <div class="card--container">
            <app-reduced-small-data-card
              title="Experiment Mode"
              [dataReading]="ExperimentModeDisplay[experiment?.experimentMode]"
            >
            </app-reduced-small-data-card>
            <app-reduced-small-data-card
              title="Organism"
              [dataReading]="experiment?.organism"
            >
            </app-reduced-small-data-card>
            <app-reduced-small-data-card
              title="Strain"
              [dataReading]="experiment?.strain"
            >
            </app-reduced-small-data-card>
            <app-reduced-small-data-card
              title="Experiment Name"
              [dataReading]="experiment?.name"
            >
            </app-reduced-small-data-card>
            <app-reduced-small-data-card
              title="Media"
              [dataReading]="experiment?.media"
            >
            </app-reduced-small-data-card>
            <div class="time-left--container">
              <div>
                @if (
                  experiment?.experimentStatusId === ExperimentStatus.Active &&
                  (currentTime$ | async); as currentTime
                ) {
                  @let timeLeft = getTimeLeft(
                    experiment.startTime,
                    experiment.duration,
                    currentTime
                  );
                  @if (timeLeft) {
                    <span class="subtitle2">
                      {{ timeLeft.days | number: "2.0" }}:{{ timeLeft.hours | number: "2.0" }}:{{ timeLeft.minutes | number: "2.0" }}:{{ timeLeft.seconds | number: "2.0" }}
                    </span>
                  } @else {
                    <span>Couldn't calculate time remaining</span>
                  }
                }
                @if (
                  experiment?.experimentStatusId === ExperimentStatus.Complete
                ) {
                  <span>--:--</span>
                }
              </div>
              <div>
                <span class="body1">Time Left</span>
              </div>
            </div>
          </div>
        </div>
        @if (unsupportedModeError) {
          <div class="unsupported-mode--container">
            <app-error-page
              title="Unsupported experiment mode"
              [primaryText]="unsupportedModeError"
            ></app-error-page>
          </div>
        } @else {
        <div id="lower">
          <!-- Optical Density graph -->
          <div class="graph--container-outer" aria-live="polite">
            <div class="graph--container-title">
              <h5>Optical Density</h5>
              <div class="menu">
                <app-mat-icon-button
                  iconName="menu"
                  buttonStyle="default"
                  [matMenuTriggerFor]="menu"
                  ariaLabel="Graph menu"
                ></app-mat-icon-button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    buttonId="download-base-unit-btn"
                    (click)="downloadBaseModuleCsv()"
                    [isProcessing]="isDownloadingBaseModuleCsv"
                    [disabled]="isDownloadingBaseModuleCsv"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Base Unit Data</span>
                  </button>
                  <button
                    mat-menu-item
                    buttonId="download-base-unit-btn"
                    (click)="downloadBaseModuleCsv(true)"
                    [isProcessing]="isDownloadingBaseModuleCsv"
                    [disabled]="
                      isDownloadingBaseModuleCsv ||
                      !(currentUser()?.role
                        | roleCheck
                          : ogiAdminAndSuperUserRoles)
                    "
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Extended Base Unit Data</span>
                  </button>
                  @if (
                    experiment &&
                    experiment.experimentMode === ExperimentMode.Turbidostat
                  ) {
                    <button
                      mat-menu-item
                      buttonId="download-turbidostat-btn"
                      (click)="downloadTurbidostatCsv()"
                      [isProcessing]="isDownloadingTurbidostatCsv"
                      [disabled]="isDownloadingTurbidostatCsv"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Turbidostat Data</span>
                    </button>
                    <button
                      mat-menu-item
                      buttonId="download-turbidostat-btn"
                      (click)="downloadTurbidostatCsv(true)"
                      [isProcessing]="isDownloadingTurbidostatCsv"
                      [disabled]="
                        isDownloadingTurbidostatCsv ||
                        !(currentUser()?.role
                          | roleCheck
                            : ogiAdminAndSuperUserRoles)
                      "
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Extended Turbidostat Data</span>
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
            @if (renderODGraph && selectedODData) {
              <app-plotly-graph
                [experimentData]="selectedODData"
                [graphId]="odGraphId"
                [yAxisLabel]="'Optical Density'"
                [isLogarithmic]="isLogarithmicChecked"
                [devices]="devices"
                graphType="OD"
                [experimentName]="experiment.name"
              ></app-plotly-graph>
            } @else if (loadingOpticalDensity) {
              <div class="loading--container">
                <app-loading-spinner
                  [label]="opticalDensityLoadingText"
                ></app-loading-spinner>
              </div>
            } @else {
              <div class="loading--container">
                <h6>{{ opticalDensityLoadingText }}</h6>
              </div>
            }
            <div class="device-select__container">
              <app-checkbox
                [checkbox]="isLogarithmic"
                [parentForm]="graphCheckboxesForm"
                (checkboxSelected)="handleLogarithmicCheckboxClicked($event)"
              ></app-checkbox>
              @if (devices) {
                <app-graph-checkbox-group
                  id="od--checks"
                  [graphId]="odGraphId"
                  [checkboxTitles]="odDeviceTitles"
                  [parentForm]="graphCheckboxesForm"
                  [field]="odFlaskCheckboxesField"
                  [formArrayGroupName]="odFlaskCheckboxesField.key"
                  (checkboxClicked)="handleFlaskCheckboxClicked($event, 'od')"
                  [isDisabled]="loadingOpticalDensity"
                ></app-graph-checkbox-group>
              }
            </div>
          </div>
          <!-- Temperature graph -->
          <div class="graph--container-outer" aria-live="polite">
            <div class="graph--container-title">
              <h5>Temperature</h5>
              <div class="menu">
                <app-mat-icon-button
                  iconName="menu"
                  buttonStyle="default"
                  [matMenuTriggerFor]="tempMenu"
                  ariaLabel="Graph menu"
                ></app-mat-icon-button>
                <mat-menu #tempMenu="matMenu">
                  <button
                    mat-menu-item
                    buttonId="download-btn"
                    (click)="downloadTemperatureCsv()"
                    [isProcessing]="isDownloadingTemperatureCsv"
                    [disabled]="isDownloadingTemperatureCsv"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Data</span>
                  </button>
                  <button
                    mat-menu-item
                    buttonId="download-btn"
                    (click)="downloadTemperatureCsv(true)"
                    [isProcessing]="isDownloadingTemperatureCsv"
                    [disabled]="
                      isDownloadingTemperatureCsv ||
                      !(currentUser()?.role
                        | roleCheck
                          : ogiAdminAndSuperUserRoles)
                    "
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Extended Data</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            @if (renderTemperatureGraph && selectedTemperatureData) {
              <app-plotly-graph
                [experimentData]="selectedTemperatureData"
                [graphId]="temperatureGraphId"
                [yAxisLabel]="'Temperature [°C]'"
                [devices]="devices"
                graphType="Temp"
                [experimentName]="experiment.name"
              ></app-plotly-graph>
            } @else if (loadingTemperature) {
              <div class="loading--container">
                <app-loading-spinner
                  [label]="temperatureLoadingText"
                ></app-loading-spinner>
              </div>
            } @else {
              <div class="loading--container">
                <h6>{{ temperatureLoadingText }}</h6>
              </div>
            }
            <div class="device-select__container">
              @if (devices) {
                <app-graph-checkbox-group
                  id="temperature--checks"
                  [graphId]="temperatureGraphId"
                  [checkboxTitles]="temperatureDeviceTitles"
                  [parentForm]="graphCheckboxesForm"
                  [field]="temperatureFlaskCheckboxesField"
                  [formArrayGroupName]="temperatureFlaskCheckboxesField.key"
                  (checkboxClicked)="
                    handleFlaskCheckboxClicked($event, 'temperature')
                  "
                  [isDisabled]="loadingTemperature"
                ></app-graph-checkbox-group>
              }
            </div>
          </div>
          <!-- Oxygen graph -->
          @if (experiment?.useOxygen) {
            <div class="graph--container-outer" aria-live="polite">
              <div class="graph--container-title">
                <h5>Oxygen</h5>
                <div class="menu">
                  <app-mat-icon-button
                    iconName="menu"
                    buttonStyle="default"
                    [matMenuTriggerFor]="oxygenMenu"
                    ariaLabel="Graph menu"
                  ></app-mat-icon-button>
                  <mat-menu #oxygenMenu="matMenu">
                    <button
                      mat-menu-item
                      buttonId="download-btn"
                      (click)="downloadOxygenCsv()"
                      [isProcessing]="isDownloadingOxygenCsv"
                      [disabled]="isDownloadingOxygenCsv"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Data</span>
                    </button>
                    <button
                      mat-menu-item
                      buttonId="download-btn"
                      (click)="downloadOxygenCsv(true)"
                      [isProcessing]="isDownloadingOxygenCsv"
                      [disabled]="
                        isDownloadingOxygenCsv ||
                        !(currentUser()?.role
                          | roleCheck
                            : ogiAdminAndSuperUserRoles)
                      "
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Extended Data</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
              @if (renderOxygenGraph && selectedOxygenData) {
                <app-oxygen-experiment-graph
                  [experimentData]="selectedOxygenData"
                  [graphId]="oxygenGraphId"
                  [yAxisLabel]="'Oxygen [%]'"
                  [devices]="devices"
                ></app-oxygen-experiment-graph>
              } @else if (loadingOxygen) {
                <div class="loading--container">
                  <app-loading-spinner
                    [label]="oxygenLoadingText"
                  ></app-loading-spinner>
                </div>
              } @else {
                <div class="loading--container">
                  <h6>{{ oxygenLoadingText }}</h6>
                </div>
              }
              <div class="device-select__container">
                @if (devices) {
                  <app-graph-checkbox-group
                    id="oxygen--checks"
                    [graphId]="oxygenGraphId"
                    [checkboxTitles]="oxygenDeviceTitles"
                    [parentForm]="graphCheckboxesForm"
                    [field]="oxygenFlaskCheckboxesField"
                    [formArrayGroupName]="oxygenFlaskCheckboxesField.key"
                    (checkboxClicked)="
                      handleFlaskCheckboxClicked($event, 'oxygen')
                    "
                    [isDisabled]="loadingOxygen"
                  ></app-graph-checkbox-group>
                }
              </div>
            </div>
          }
          <!-- pH graph -->
          @if (experiment?.usePH) {
            <div class="graph--container-outer" aria-live="polite">
              <div class="graph--container-title">
                <h5>pH</h5>
                <div class="menu">
                  <app-mat-icon-button
                    iconName="menu"
                    buttonStyle="default"
                    [matMenuTriggerFor]="pHMenu"
                    ariaLabel="Graph menu"
                  ></app-mat-icon-button>
                  <mat-menu #pHMenu="matMenu">
                    <button
                      mat-menu-item
                      buttonId="download-btn"
                      (click)="downloadPhCsv()"
                      [isProcessing]="isDownloadingPhCsv"
                      [disabled]="isDownloadingPhCsv"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Data</span>
                    </button>
                    <button
                      mat-menu-item
                      buttonId="download-btn"
                      (click)="downloadPhCsv(true)"
                      [isProcessing]="isDownloadingPhCsv"
                      [disabled]="
                        isDownloadingPhCsv ||
                        !(currentUser()?.role
                          | roleCheck
                            : ogiAdminAndSuperUserRoles)
                      "
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Extended Data</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
              @if (renderPHGraph && selectedPHData) {
                <app-plotly-graph
                  [experimentData]="selectedPHData"
                  [graphId]="pHGraphId"
                  [yAxisLabel]="'pH'"
                  [devices]="devices"
                  graphType="pH"
                  [experimentName]="experiment.name"
                ></app-plotly-graph>
              } @else if (loadingPH) {
                <div class="loading--container">
                  <app-loading-spinner
                    [label]="pHLoadingText"
                  ></app-loading-spinner>
                </div>
              } @else {
                <div class="loading--container">
                  <h6>{{ pHLoadingText }}</h6>
                </div>
              }
              <div class="device-select__container">
                @if (devices) {
                  <app-graph-checkbox-group
                    id="pH--checks"
                    [graphId]="pHGraphId"
                    [checkboxTitles]="pHDeviceTitles"
                    [parentForm]="graphCheckboxesForm"
                    [field]="pHFlaskCheckboxesField"
                    [formArrayGroupName]="pHFlaskCheckboxesField.key"
                    (checkboxClicked)="handleFlaskCheckboxClicked($event, 'pH')"
                    [isDisabled]="loadingPH"
                  ></app-graph-checkbox-group>
                }
              </div>
            </div>
          }
          <!-- Fluorescence graph -->
          @if (experiment?.useFluorescence) {
            <div class="graph--container-outer" aria-live="polite">
              <div class="graph--container-title">
                <h5>Fluorescence</h5>
                <div class="menu">
                  <app-mat-icon-button
                    iconName="menu"
                    buttonStyle="default"
                    [matMenuTriggerFor]="fluoroMenu"
                    ariaLabel="Graph menu"
                  ></app-mat-icon-button>
                  <mat-menu #fluoroMenu="matMenu">
                    @if (experiment?.fluorescenceChannels?.length > 0) {
                      <button
                        mat-menu-item
                        buttonId="download-btn"
                        (click)="downloadFluorescenceCsv('channels')"
                        [isProcessing]="isDownloadingFluorescenceCsv"
                        [isDisabled]="isDownloadingFluorescenceCsv"
                      >
                        <mat-icon>download</mat-icon>
                        <span>Download Channel Data</span>
                      </button>
                    }
                    <button
                      mat-menu-item
                      buttonId="download-btn"
                      (click)="downloadFluorescenceCsv('spectrum')"
                      [isProcessing]="isDownloadingFluorescenceCsv"
                      [isDisabled]="isDownloadingFluorescenceCsv"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Spectrum Data</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
              @if (renderFluorescenceGraph && selectedFluorescenceData) {
                <app-fluoro-experiment-graph
                  [experimentData]="selectedFluorescenceData"
                  [graphId]="fluorescenceGraphId"
                  [yAxisLabel]="'Fluorescence'"
                  [devices]="devices"
                  [fluorescenceChannels]="experiment?.fluorescenceChannels"
                ></app-fluoro-experiment-graph>
              } @else if (isFetchingFluorescenceData) {
                <div class="loading--container">
                  <app-loading-spinner
                    [label]="fluorescenceLoadingText"
                  ></app-loading-spinner>
                </div>
              } @else {
                <div class="loading--container">
                  <h6>{{ fluorescenceLoadingText }}</h6>
                </div>
              }
              <div class="device-select__container">
                @if (devices) {
                  <app-graph-checkbox-group
                    id="fluorescence--checks"
                    [graphId]="fluorescenceGraphId"
                    [checkboxTitles]="fluorescenceDeviceTitles"
                    [parentForm]="graphCheckboxesForm"
                    [field]="fluorescenceFlaskCheckboxesField"
                    [formArrayGroupName]="fluorescenceFlaskCheckboxesField.key"
                    (checkboxClicked)="
                      handleFlaskCheckboxClicked($event, 'fluorescence')
                    "
                    [isDisabled]="loadingFluorescence"
                  ></app-graph-checkbox-group>
                }
              </div>
            </div>
          }
        </div>
        }
      </section>
    </div>
  </div>
} @else {
  <app-error-page [primaryText]="getExperimentError?.message"></app-error-page>
}
<app-validation-modal
  id="pause-device"
  [titleText]="pauseDeviceTitleText"
  [validationText]="pauseDeviceValidationText"
  [primaryButtonText]="pauseDeviceButtonText"
  primaryButtonId="primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="secondary-button"
  (modalButtonClicked)="pauseRestartDevices()"
  [error]="error"
></app-validation-modal>
